import { StyledButton } from '../styleComponents/StyledButton.style';

const Button = () => {
  return <StyledButton type='submit'>Save Note</StyledButton>;
};

export default Button;
